import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import Favicon from "react-favicon";
import favicon from "./themes/favicon/favicon.ico";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles, MuiThemeProvider } from "@material-ui/core/styles";
import { MM_THEME } from "./themes/theme";
import { LOCALE_ES, ROUTES_LOGIN, SECTION_LOGIN, SESSION_TOKEN_STORAGE_KEY } from "./utils/constants";
import esCustomMessages from "./i18n/es-messages.json";
import { Provider } from "react-redux";
import store from "./store";
import LoginHeader from "./layout/Header";
import { Outlet, useNavigate } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import CustomMenu from "./layout/CustomMenu";
import CustomAlert from "./components/custom-alert/custom-alert";

const messages = {
  [LOCALE_ES]: esCustomMessages,
};

const useStyles = makeStyles((theme) => ({
  appRoot: {
    minHeight: "100vh",
  },
  contentContainer: {
    display: "flex",
    height: "calc(100vh - 87px)",
  },
  main: {
    flex: 1,
    padding: theme.spacing(4, 2),
  },
}));

const App = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const token = sessionStorage.getItem(SESSION_TOKEN_STORAGE_KEY);

  const [open, setOpen] = useState(true);

  const handleOpenMenu = () => {
    setOpen((open) => !open);
  };

  const redirectToLogin = () => {
    const path = window.location.pathname.split("/")[3];
    path !== SECTION_LOGIN && navigate(ROUTES_LOGIN);
  };

  useEffect(() => {
    !token && redirectToLogin();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <>
      {favicon && <Favicon url={favicon} />}
      <IntlProvider locale={LOCALE_ES} messages={messages[LOCALE_ES]} defaultLocale={LOCALE_ES}>
        <Provider store={store}>
          <MuiThemeProvider theme={MM_THEME}>
            <CssBaseline />
            <Grid container direction={"column"} className={classes.appRoot}>
              <Grid item>
                <header>
                  <LoginHeader handleOpenMenu={handleOpenMenu} open={open} />
                </header>
              </Grid>
              <Grid item className={classes.contentContainer}>
                {!!token && <CustomMenu open={open} />}
                <main className={classes.main}>
                  <Outlet />
                </main>
              </Grid>
            </Grid>
            <CustomAlert />
          </MuiThemeProvider>
        </Provider>
      </IntlProvider>
    </>
  );
};

export default App;
